import type { SelectProps } from "antd";
import type { ReactNode } from "react";
import CustomSelect from "../../CustomSelect";
import { FormItem, type FormItemProps } from "../FormItem";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;

  /** `children` moved out of `selectProps` for convenience as it used frequently */
  children?: SelectProps["children"];
  /** `disabled` moved out of `selectProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `SelectProps`. */
  selectProps?: Omit<SelectProps, "disabled" | "children">;
};

export const FormSelect = <TForm = unknown>({ label, disabled, selectProps, children, ...rest }: Props<TForm>) => (
  <div>
    <FormItem<TForm> className="form-select-item" layout="vertical" label={label} {...rest}>
      <CustomSelect disabled={disabled} {...selectProps}>
        {children}
      </CustomSelect>
    </FormItem>
  </div>
);
